export default function AnalyzingCard({ fileName }) {
  const bars = Array.from({ length: 28 });
  return (
    <div
      className="bg-[#0A0A0A] border border-white/5 rounded-3xl p-8 shadow-2xl flex flex-col items-center justify-center min-h-[300px]"
      data-testid="analyzing-indicator"
    >
      {/* Waveform */}
      <div className="flex items-center justify-center gap-1 h-20 w-full max-w-[280px] mb-8">
        {bars.map((_, i) => (
          <span
            key={i}
            className="wave-bar w-1.5 bg-[#FF2D55] rounded-full"
            style={{
              height: `${20 + (i % 5) * 12}px`,
              animationDelay: `${(i * 0.06) % 1.1}s`,
              opacity: 0.4 + ((i % 5) * 0.12),
            }}
          />
        ))}
      </div>

      <div
        className="text-[10px] uppercase tracking-[0.3em] text-[#FF2D55] font-mono font-semibold mb-3"
        aria-live="polite"
      >
        analyzing audio
      </div>
      <div className="text-sm text-zinc-400 font-body text-center">
        Listening for tonal center, chroma, and key signature…
      </div>
      {fileName && (
        <div className="mt-5 px-3 py-1.5 rounded-full bg-white/5 border border-white/5 text-[11px] text-zinc-500 font-mono max-w-[260px] truncate">
          {fileName}
        </div>
      )}
    </div>
  );
}
